import styleguide from '@common/styleguide';
import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

// This is an especially custom icon: colors are hardcoded, and it's meant to be
// rendered as 31x30.
// Be careful with how / where this is used to ensure it renders as expected.
export const SharedNoBlend: FC<IconSVGComponentProps> = (props) => {
    return (
        <IconSVG
            stroke="0"
            viewBox="0 0 31 30"
            width="31px"
            height="30px"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.128 20.9391C4.92624 20.3259 0.890538 15.8886 0.890538 10.5057C0.890538 4.70355 5.57935 0 11.3633 0C16.7289 0 21.1521 4.04782 21.7639 9.26542C21.3587 9.21767 20.9465 9.19311 20.5286 9.19311C14.7446 9.19311 10.0558 13.8967 10.0558 19.6988C10.0558 20.1184 10.0803 20.5323 10.128 20.9391Z"
                fill={styleguide.colors.blue}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.6529 9.06095C26.8547 9.67409 30.8904 14.1114 30.8904 19.4943C30.8904 25.2964 26.2016 30 20.4177 30C15.052 30 10.6288 25.9522 10.0171 20.7346C10.4223 20.7823 10.8345 20.8069 11.2524 20.8069C17.0363 20.8069 21.7252 16.1033 21.7252 10.3012C21.7252 9.88159 21.7006 9.46772 21.6529 9.06095Z"
                fill={styleguide.colors.orangeBright}
            />
        </IconSVG>
    );
};
